import moment from "moment";
import isequal from "lodash.isequal";
import {
  HOUR_FORMAT,
  ID_PAZIENTE,
  INIZIALI_PAZIENTE,
  ANNO_NASCITA,
  DATA_INTERVENTO,
  INGRESSO_BLOCCO_OPERATORIO,
  INGRESSO_SALA_OPERATORIA,
  USCITA_SALA_OPERATORIA,
  USCITA_BLOCCO_OPERATORIO,
} from "./index";

const ID_PAZIENTE_API = "id_paziente";
const INIZIALI_PAZIENTE_API = "iniziali_paziente";
const ANNO_NASCITA_API = "anno_nascita";
const DATA_INTERVENTO_API = "data_intervento";
const INGRESSO_BLOCCO_API = "t_ingresso_blocco";
const INGRESSO_SALA_OPERATORIA_API = "t_ingresso_sala";
const USCITA_SALA_OPERATORIA_API = "t_uscita_sala";
const USCITA_BLOCCO_API = "t_uscita_blocco";

export const preparaDatiIntervento = (idStruttura, data) => {
  let newData = {};
  for (const [key, value] of Object.entries(data)) {
    if (key === ID_PAZIENTE_API && value && value !== undefined) newData[ID_PAZIENTE] = value;
    else if (key === INIZIALI_PAZIENTE_API && value && value !== undefined) newData[INIZIALI_PAZIENTE] = value;
    else if (key === ANNO_NASCITA_API && value && value !== undefined) newData[ANNO_NASCITA] = value;
    else if (key === DATA_INTERVENTO_API && value && value !== undefined) newData[DATA_INTERVENTO] = value;
    else if (key === INGRESSO_BLOCCO_API && value && value !== undefined && value.trim().length > 0) newData[INGRESSO_BLOCCO_OPERATORIO] = moment(value).format(HOUR_FORMAT); //prettier-ignore
    else if (key === INGRESSO_SALA_OPERATORIA_API && value && value !== undefined && value.trim().length > 0) newData[INGRESSO_SALA_OPERATORIA] = moment(value).format(HOUR_FORMAT); //prettier-ignore
    else if (key === USCITA_SALA_OPERATORIA_API && value && value !== undefined && value.trim().length > 0) newData[USCITA_SALA_OPERATORIA] = moment(value).format(HOUR_FORMAT); //prettier-ignore
    else if (key === USCITA_BLOCCO_API && value && value !== undefined && value.trim().length > 0) newData[USCITA_BLOCCO_OPERATORIO] = moment(value).format(HOUR_FORMAT); //prettier-ignore
  }
  const infoIntervento = { idStruttura, ...newData };
  return infoIntervento;
};

export const comparaDatiIntervento = (idStruttura, data, situazionePrecedente) => {
  let datiCambiati = false;
  const situazioneAttuale = preparaDatiIntervento(idStruttura, data);
  if (!isequal(situazionePrecedente, situazioneAttuale)) datiCambiati = true;
  const comparata = { datiCambiati, infoIntervento: situazioneAttuale };
  return comparata;
};
